module.exports = __webpack_public_path__ + "img/HeavyEquipment.83ad2ef4.gif";